import { FALLBACK_COMPONENTS, ModuleFederationComponents } from '../module-federation/constants';
import { moduleFederation } from '../module-federation/module-federation';
import type { PromozavrRendererSource } from './types';

export function getPromozavrRendererSource(shouldUsePdokPromoRenderer: boolean): PromozavrRendererSource {
    if (!shouldUsePdokPromoRenderer) {
        return 'local';
    }

    const promoRendererModule = moduleFederation?.getComponent(ModuleFederationComponents.PromoRenderer);
    const fallbackPromoRendererModule = FALLBACK_COMPONENTS[ModuleFederationComponents.PromoRenderer];

    if (promoRendererModule && promoRendererModule !== fallbackPromoRendererModule) {
        return 'remote';
    }

    return 'local';
}
